// extracted by mini-css-extract-plugin
module.exports = {"textLink":"TextLink_textLink__30GXr"};